<h2>{{'AppManager'|translate}}</h2>
<mat-nav-list *ngIf="doShowDashboard">
    <div class="col-12 p-0 d-flex">
        <a style="background:none;" mat-list-item (click)="redirectPlatform()" class="dashboard p-0">
            <mat-icon class="p-0 ml-2" matListIcon>explore</mat-icon>
            <h4 mat-line class="ml-2">{{'My health+ Home'|translate}}</h4>
            <mat-divider></mat-divider>
        </a>
    </div>
</mat-nav-list>
<div class="subscribe-container" *ngIf="subscribeAlert">
    <div class="d-flex justify-content-between pl-3 pr-3 pb-3">
        <i class="material-icons mr-3 refresh-icon">refresh</i>
        <div>{{'Your'|translate}} {{appStatus}} for {{appName}} {{'is in pending soon you will get the access'|translate}}</div>
    </div>
</div>
<div class="app-manager">
    <mat-nav-list>
        <ng-container *ngFor="let note of appLists; let i = index">
            <a mat-list-item class="p-0 row m-0" *ngIf="isAppAvailableForCountry(note)">
                <div class="col-12 p-0 d-flex">
                    <div class="app-img col-2">
                        <img class="message-icon-app" src="{{note.appIconUrl}}" />
                    </div>
                    <div class="col-10 p-0 d-flex justify-content-between">
                        <div id="{{getAppName(note)}}" mat-line (click)="getMainPanel(note)">{{translate.instant(getAppName(note))}}</div>
                        <div title="Unsubscribe" class="d-flex text-right float-corner" id="{{getAppName(note)}}_subscribe" (click)="appSubscription(note, i)"
                            *ngIf="note.isUserSubscribed && note.isUserApproved && !hideSubscribe">
                            <span *ngFor="let innerItm of note.applicationSettings; let it = index;">
                                <span *ngIf="innerItm.country == profileData.country">
                                    <span class="cursor unsub-name" *ngIf="innerItm.applicationDetails?.isUnsubscribeRequired">
                                        <i class="material-icons desubscribe-style">remove_circle_outline</i>
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            </a>
        </ng-container>
    </mat-nav-list>
</div>

<div class="app-manager-subscribe" *ngIf="!hideSubscribe">
    <mat-nav-list>
        <div mat-subheader class="p-0 mt-0">
            <small class="font-weight-bold">{{'Marketplace'|translate}}</small>
        </div>
        <mat-divider></mat-divider>
        <ng-container *ngFor="let note of newLists; let i = index">
            <a mat-list-item class="p-0 row m-0" *ngIf="isAppAvailableForCountry(note)" [ngClass]="{'disableClass': !note.isActive}">
                <div class="col-12 p-0 d-flex">
                    <div class="app-img col-2">
                        <img class="message-icon-app" src="{{note.appIconUrl}}" />
                    </div>
                    <div class="col-10 p-0 d-flex justify-content-between">
                        <div mat-line id="{{getAppName(note)}}" (click)="getMainPanel(note)">{{translate.instant(getAppName(note))}}</div>
                        <div>
                            <span title="Pending Approval" class="pending-link-color text-right" [hidden]="!note.isActive" *ngIf="note.isUserSubscribed && !note.isUserApproved">
                                <img class="mr-2 favorite-img cursor" src="assets/img/icons/pending-approval.svg" />
                            </span>

                            <div title="Subscribe" class="d-flex round-corner-subscribe11 text-right" [ngClass]="{'appmanager-disclass': !note.isActive}"
                                (click)="appSubscription(note, i)" *ngIf="!note.isUserSubscribed && !note.isUserApproved && !hideSubscribe">
                                <i id="{{getAppName(note)}}_icon" class="material-icons mr-2 subscribe-style">add_circle_outline</i>
                            </div>

                        </div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            </a>
        </ng-container>
    </mat-nav-list>
</div>